var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F0F1EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0034 18H18.0102M21 18H21.0068M15.0068 18H15.0135",
    stroke: "#9CA37F",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.125 17.9999C25.125 21.935 21.935 25.1249 18 25.1249C16.7789 25.1249 15.6296 24.8177 14.625 24.2765C13.2238 23.5214 12.281 24.2234 11.4494 24.3493C11.3233 24.3684 11.1977 24.3226 11.1075 24.2324C10.9706 24.0955 10.9445 23.8838 11.0201 23.7055C11.3465 22.9363 11.6461 21.4786 11.2376 20.2499C11.0023 19.5427 10.875 18.7862 10.875 17.9999C10.875 14.0649 14.065 10.8749 18 10.8749C21.935 10.8749 25.125 14.0649 25.125 17.9999Z",
    stroke: "#9CA37F",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.19e767093e54e111770ccfa9e7138452.svg";
export { ForwardRef as ReactComponent };